/* GreenIT V3.2 – product page enhancements.
   1. Split the product title at the first "|" (title + smaller spec line as pills).
   2. Mobile only: move the title/specs and a live price above the product
      image, and simplify the sticky bottom bar to price + Buy Now.
   The mobile price copies the real price and is kept in sync when the
   shopper changes variant (via a MutationObserver on the real price). */
(function () {
  var MOBILE = '(max-width: 749px)';
  function isMobile() {
    return window.matchMedia && window.matchMedia(MOBILE).matches;
  }
  function priceSource() {
    return document.querySelector('.product__info-container .price');
  }

  /* ---- 1. Title split + spec pills ---- */
  function splitOne(wrap) {
    if (!wrap || wrap.dataset.pwnSplit) return;
    var h1 = wrap.querySelector('h1');
    var target = h1 || wrap;
    var full = (target.textContent || '').trim();
    var idx = full.indexOf('|');
    if (idx === -1) return;
    var main = full.slice(0, idx).trim();
    var rest = full.slice(idx + 1).trim();
    if (h1) { h1.textContent = main; } else { wrap.textContent = main; }
    wrap.dataset.pwnSplit = '1';
    if (rest) {
      var sub = document.createElement('div');
      sub.className = 'product__subtitle';
      rest.split('|').forEach(function (part) {
        var p = part.trim();
        if (!p) return;
        var pill = document.createElement('span');
        pill.className = 'pwn-pill';
        pill.textContent = p;
        sub.appendChild(pill);
      });
      wrap.appendChild(sub);
    }
  }
  function splitTitle() {
    var wraps = document.querySelectorAll('.product__title');
    for (var i = 0; i < wraps.length; i++) { splitOne(wraps[i]); }
  }

  /* ---- 2a. Mobile: title + price above the image ---- */
  function mobileRearrange() {
    if (!isMobile()) return;
    var media = document.querySelector('.product__media-wrapper');
    if (!media || media.dataset.pwnMoved) return;
    media.dataset.pwnMoved = '1';
    var parent = media.parentNode;

    // Move ONLY the title (+ spec line) above the image, not the icon spec
    // list or warranty, and add a price beside it.
    var title = document.querySelector('.custom_middle_part .product__title') ||
                document.querySelector('.product__title');
    var head = document.createElement('div');
    head.className = 'pwn-mobile-head';
    if (title) { head.appendChild(title); }
    var pc = document.createElement('div');
    pc.className = 'pwn-mobile-price';
    head.appendChild(pc);
    parent.insertBefore(head, media);
  }

  /* ---- 2b. Mobile: simplify the sticky bottom bar ---- */
  function simplifyStickyBar() {
    if (!isMobile()) return;
    var det = document.querySelector('.product-sticky-bar .product_deatails');
    if (det) { det.dataset.pwnStickyPrice = '1'; }
    var btn = document.querySelector('.product-sticky-bar .sticky_btn');
    if (btn && !btn.dataset.pwnDone) {
      btn.dataset.pwnDone = '1';
      btn.textContent = 'Buy Now';
    }
  }

  /* ---- Keep the mobile price copies in sync with the real price ---- */
  function syncPrices() {
    if (!isMobile()) return;
    var src = priceSource();
    if (!src) return;
    var html = src.innerHTML;
    var targets = document.querySelectorAll('.pwn-mobile-price, .product-sticky-bar [data-pwn-sticky-price]');
    for (var i = 0; i < targets.length; i++) {
      if (targets[i].innerHTML !== html) { targets[i].innerHTML = html; }
    }
  }

  function run() {
    splitTitle();
    mobileRearrange();
    simplifyStickyBar();
    syncPrices();
  }

  run();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  }

  if (!window.__greenitPwnInit) {
    window.__greenitPwnInit = true;

    // Re-sync the mobile price whenever the real price changes (variant switch).
    var host = document.querySelector('.product__info-container');
    if (host && window.MutationObserver) {
      var mo = new MutationObserver(function () { syncPrices(); });
      mo.observe(host, { childList: true, subtree: true, characterData: true });
    }

    // The sticky bar can render slightly after load; apply a few times.
    var tries = 0;
    var iv = setInterval(function () {
      splitTitle();
      simplifyStickyBar();
      syncPrices();
      if (++tries > 8) clearInterval(iv);
    }, 400);
  }
})();
